// extracted by mini-css-extract-plugin
export default {"root":"banner-module--root--6fd20","title":"banner-module--title--13aaa","content":"banner-module--content--0d262","imageBlock":"banner-module--image-block--e915f"};